import Vue from 'vue';
export default {

  isAppVersionBiggerThan(criticality) {
    if (!criticality) {
      // eslint-disable-next-line no-param-reassign
      criticality = [4, 10, 1];
    }
    const str = navigator.userAgent.toLowerCase();
    if (!str) {
      return false;
    }
    if (str.match('tgclub') === null) {
      return false;
    }
    const reg = new RegExp('tgclub/([0-9.]+)');
    const res  = str.match(reg);
    if (!res || !res[1]) {
      return false;
    }
    const banbenArr = res[1].split('.').map(num => parseInt(num, 10));
    if (banbenArr[0] > criticality[0]) {
      return true;
    } if (banbenArr[0] === criticality[0] && banbenArr[1] > criticality[1]) {
      return true;
    } if (banbenArr[0] === criticality[0] && banbenArr[1] === criticality[1] && banbenArr[2] >= criticality[2]) {
      return true;
    }
    return false;
  },
  hasDownloadPakage(pkgName) {
    return window.Tgclub.getAppChannelInfo(pkgName, 'channelId');
  },
  isTgClubChanneID(pkgName) {
    return window.Tgclub.getAppChannelInfo(pkgName, 'channelId') && parseInt(window.Tgclub.getAppChannelInfo(pkgName, 'channelId'), 10)
      === 10030476;
  },
  isInstall(pkgName) {
    return typeof window.Tgclub.isAppInstalled !== 'undefined' && window.Tgclub.isAppInstalled(pkgName);
  },

  getTimeStamp(time) {
    if (time) {
      // ios 的时间格式需要更改一下
      // eslint-disable-next-line no-param-reassign
      time = time.replace(/-/g, '/');
      return parseInt(new Date(time).getTime() / 1000, 10);
    }
    return parseInt(new Date().getTime() / 1000, 10);
  },
  // 染色SDK曝光上报
  reportGameChanelDownloadViewShow(gameInfo) {
    console.log('access reportGameChanelDownloadViewShow');
    if (!window.Tgclub) {
      return false;
    }
    if (window.Tgclub && typeof  window.Tgclub.downloadViewShow !== 'function') {
      return false;
    }
    // 需要判断版本，ios是5.7.14及以上，安卓是5.7.8及以上
    const checkVersionRes = this.isAppVersionBiggerThan(Vue.prototype.$platform.isAndroid ?  [5, 7, 8] : [5, 7, 14]);
    console.log('app check checkVersionRes', checkVersionRes);
    if (checkVersionRes === true) {
      const jsonStr = JSON.stringify(gameInfo);
      window.Tgclub.downloadViewShow(jsonStr);
      console.log('app downloadViewShow report success');
    } else {
      console.log('app downloadViewShow not report ');
    }
  },

};
